mutation ResumeAutomatedEmails {
    resumeAutomatedEmails {
        user {
            id
        }
    }
}
